// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import TournamentStructure from '../tournamentStructure';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { colors, btn, btnGroup, card, form, modal, search as searchStyles, spinner } from '../../../../style/common/partnerStyle';
var Spinner = require('react-spinkit');

class TournamentCompetition extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venues: [],
      sub_categories: {},
      tournament_id : props.tournament_id,
      show_competition_id : props.competitions_id,
      view_type :props.view_type,
      initialView:props.initialView,
      games: [],
      mobile_no:'',
      categories: [],
      age_groups: [],
      genders: [],
      coordinaters:[],
      buddy_search_list:[],
      showStructure:false,
      competitions_id:'',
      city:[],
      additional_fields:[],
      is_loading: false,
      competition_details : {
              tournament_id: props.tournament_id,
              game:'',
              category:'',
              gender:'',
              age_group:'',
              prize_and_perks:'',
              description:'',
              registration_amount:0,
              coordinaters:[],
              venue:[],
              start_date: moment(),
              end_date: moment(),
              registration_closed: moment(),
              is_team_competition:true
            },
      prev_competition_details:null,
      addNewCompetitionView:false,
      ShowCompetition:false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getCompetitionDetail = this.getCompetitionDetail.bind(this);
    this.getSearchList = this.getSearchList.bind(this);
    this.setSearch = this.setSearch.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.handleEndDate = this.handleEndDate.bind(this);
    this.handleRegDate = this.handleRegDate.bind(this);
    this.handleStartDatePre = this.handleStartDatePre.bind(this);
    this.handleEndDatePre = this.handleEndDatePre.bind(this);
    this.handleRegDateTime = this.handleRegDateTime.bind(this);
  }

  componentDidMount() {
    const isAddNew = this.state.view_type == 'addnew';

    // Only show loading spinner when fetching existing competition data
    if (!isAddNew) {
      this.setState({ is_loading: true });
    }

    this.getTournamentDetails();

    if (isAddNew) {
      // Add mode: no competition to fetch, go straight to the form
      this.setState({ addNewCompetitionView: true });
    } else {
      // Edit mode: fetch the competition then show the form
      this.getCompetitionDetail();
      this.setState({ ShowCompetition: true });
    }
  }

  getTournamentDetails() {
    const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament_competition/?tournament_id=${this.state.tournament_id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => {
        this.setState({
          venues: data.venues,
          city: data.cities,
          sub_categories: data.sub_categories,
          games: data.games,
          categories: data.categories,
          age_groups: data.age_groups,
          genders: data.genders,
          additional_fields: data.registration_additional_fields,
        });
      })
      .catch(error => error);
  }

  handleStartDate(date) {
    var new_selected_one = Object.assign({}, this.state.competition_details);
    new_selected_one['start_date'] = date;
    this.setState({ competition_details: new_selected_one });
  }
  handleEndDate(date) {
    var new_selected_one = Object.assign({}, this.state.competition_details);
    new_selected_one['end_date'] = date;
    this.setState({ competition_details: new_selected_one });
  }
  handleRegDate(date) {
    var new_selected_one = Object.assign({}, this.state.competition_details);
    new_selected_one['registration_closed'] = date;
    this.setState({ competition_details: new_selected_one });
  }
  handleStartDatePre(date) {
    var new_selected_one = Object.assign({}, this.state.prev_competition_details);
    new_selected_one['start_date'][1] = date;
    this.setState({ prev_competition_details: new_selected_one });
  }
  handleEndDatePre(date) {
    var new_selected_one = Object.assign({}, this.state.prev_competition_details);
    new_selected_one['end_date'][1] = date;
    this.setState({ prev_competition_details: new_selected_one });
  }
  handleRegDateTime(event) {
    const new_selected_one = Object.assign({}, this.state.prev_competition_details);
    const [date, time] = event.target.value.split('T');
    new_selected_one['registration_closed'][1] = moment(`${date} ${time}`);
    this.setState({ prev_competition_details: new_selected_one });
  }

  getCompetitionDetail() {
    const competition_id = this.state.show_competition_id;

    if (!competition_id) {
      console.warn('TournamentCompetition: no competition_id provided, skipping fetch');
      this.setState({ is_loading: false });
      return;
    }

    const url = `${getLocationOrigin()}/tournament/get_competition_detail_to_show/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({ 'competition_id': competition_id });

    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        try {
          // Guard: competitions_list may be null, an object, or unexpectedly an array.
          // A bad shape must never silently block the spinner.
          const comp = data && data.competitions_list;
          if (comp && !Array.isArray(comp)) {
            const start_date = moment(comp.start_date[1]);
            const end_date   = moment(comp.end_date[1]);
            const registration_closed = comp.registration_closed
              ? moment(comp.registration_closed[1])
              : moment().set({ hour: 23, minute: 59, second: 0, millisecond: 0 });

            const updated = Object.assign({}, comp);
            if (!updated['registration_closed']) { updated['registration_closed'] = []; }
            updated['start_date'][1]          = start_date;
            updated['end_date'][1]            = end_date;
            updated['registration_closed'][1] = registration_closed;

            this.setState({ prev_competition_details: updated });
          } else {
            this.setState({ prev_competition_details: null });
          }
        } catch (parseError) {
          console.error('Error processing competition details:', parseError);
          this.setState({ prev_competition_details: null });
        }
      })
      .catch(error => {
        console.log(error);
        if (error && error.message) { alert(error.message); }
      })
      .finally(() => {
        // Guaranteed to run regardless of success, failure, or any thrown exception
        this.setState({ is_loading: false });
      });
  }

  postCreateCompetition() {
    var data = this.state.competition_details;
    console.log(data);
    if(data.age_group == '') { data.age_group = this.state.age_groups[0].id; }
    if(data.category == '') { data.category = this.state.categories[0][0]; }
    if(data.gender == '') { data.gender = this.state.genders[0][0]; }
    if(data.game == '') { data.game = this.state.games[0].pk; }
    const url = `${getLocationOrigin()}/tournament/add_tournament_competition/`;
    const options = {...defaultOptions};
    var formData = new FormData();
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({
      'tournament_id': data.tournament_id,
      'registration_amount': data.registration_amount,
      'prize_and_perks': data.prize_and_perks,
      'category': data.category,
      'game': data.game,
      'gender': data.gender,
      'age_group': data.age_group,
      'coordinaters': data.coordinaters,
      'venue': data.venue,
      'start_date': data.start_date,
      'end_date': data.end_date,
      'registration_closed': data.registration_closed,
      'description': data.description,
    });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then((response) => {
        alert(response.message);
        if(response.success) {
          this.setState({ competitions_id: response.competitions_id, showStructure: true, ShowCompetition: false, addNewCompetitionView: false });
        }
      })
      .catch(error => { console.log(error); alert(error.message); });
      //this.setState({showStructure:true,ShowCompetition:false,addNewCompetitionView:false});
  }

  getSearchList() {
    var mobile_no = this.state.mobile_no;
    const url = `${getLocationOrigin()}/eagleeye/search_buddy/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({ 'search': mobile_no });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => this.setState({ buddy_search_list: data.results, search: true }))
      .catch(error => { console.log(error); alert(error.message); });
  }

  setSearch(name, buddy_id, mobile_no) {
    var new_selected_one = Object.assign({}, this.state.competition_details);
    new_selected_one.coordinaters.push(buddy_id);
    this.setState({ competition_details: new_selected_one, search: false });
    this.state.coordinaters.push([buddy_id, name]);
  }

  setCordinater(name, buddy_id, mobile_no) {
    var new_selected_one = Object.assign({}, this.state.prev_competition_details);
    new_selected_one.coordinator.push([buddy_id, name]);
    this.setState({ prev_competition_details: new_selected_one, search: false });
  }

  removeCoordinater(name, coordinator_id) {
    var new_selected_one = Object.assign({}, this.state.competition_details);
    new_selected_one.coordinaters.pop(coordinator_id);
    this.setState({ competition_details: new_selected_one, search: false });
    this.state.coordinaters.pop([coordinator_id, name]);
  }

  removeCoordinaterPrev(name, coordinator_id) {
    var new_selected_one = Object.assign({}, this.state.prev_competition_details);
    new_selected_one.coordinater.pop(coordinator_id);
    this.setState({ prev_competition_details: new_selected_one, search: false });
    this.state.coordinaters.pop([coordinator_id, name]);
  }

  handleChangeForNew(event) {
    console.log(event.target.name, event.target.value);
    var name = event.target.name;
    if(name == 'mobile_no') { this.setState({ mobile_no: event.target.value }); }
    else {
      var new_selected_one = Object.assign({}, this.state.competition_details);
      new_selected_one[name] = event.target.value;
      this.setState({ competition_details: new_selected_one });
    }
  }

  handleMultiselect(event) {
    const name = event.target.name;
    var options = event.target.options;
    var new_selected_one = Object.assign({}, this.state.competition_details);
    var ids = [];
    if(event) {
      for (var i = 0, l = options.length; i < l; i++) {
        if (options[i].selected) { ids.push(options[i].value); }
      }
    }
    else {}
    new_selected_one[name] = ids;
    this.setState({ competition_details: new_selected_one });
  }

  handleMultiselectPrev(event) {
    const name = event.target.name;
    var options = event.target.options;
    var new_selected_one = Object.assign({}, this.state.prev_competition_details);
    var ids = [];
    if(event) {
      for (var i = 0, l = options.length; i < l; i++) {
        if (options[i].selected) { ids.push([options[i].value, name]); }
      }
    }
    else {}
    new_selected_one[name] = ids;
    this.setState({ prev_competition_details: new_selected_one });
  }

  handleChange(event, struct_id) {
    var name = event.target.name;
    var new_selected_one = this.state.prev_competition_details;
    if(name == 'game' || name == 'age_groups' || name == 'gender' || name == 'category') {
      new_selected_one[name][0] = event.target.value;
    }
    else { new_selected_one[name] = event.target.value; }
    this.setState({ prev_competition_details: new_selected_one });
  }

  postSaveCompetition() {
    var data = this.state.prev_competition_details;
    if(!data.city) { data.city = null; }
    if(!this.state.additional_fields.includes('cities') && data.city) { data.city = null; }
    console.log(data);
    console.log("data collected");
    const url = `${getLocationOrigin()}/tournament/save_tournament_Competition/`;
    const options = {...defaultOptions};
    var formData = new FormData();
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({
      'id': data.id,
      'tournament_id': this.state.tournament_id,
      'registration_amount': data.registration_amount,
      'prize_and_perks': data.prize_and_perks,
      'category': data.category[0],
      'game': data.game[0],
      'gender': data.gender[0],
      'age_group': data.age_groups[0],
      'coordinater': data.coordinator,
      'venue': data.venue,
      'city': data.city,
      'start_date': data.start_date[1],
      'end_date': data.end_date[1],
      'registration_closed': data.registration_closed[1],
      'description': data.description,
    });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(function(response) { alert(response.message); window.location.reload(); })
      .catch(error => { console.log(error); alert(error.message); });
  }

  deleteCompetition() {
    const url = `${getLocationOrigin()}/tournament/delete_tournament_competition/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({ 'competition_id': this.state.prev_competition_details.id });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => { alert(data.message); window.location.reload(); })
      .catch(error => { console.log(error); alert(error.message); });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postCreateCompetition();
  }

  toShowCompetitionView() {
    this.setState({ ShowCompetition: !this.state.ShowCompetition, addNewCompetitionView: false });
  }

  toAddCompetitionView() {
    this.setState({ addNewCompetitionView: !this.state.addNewCompetitionView, ShowCompetition: false });
  }

  renderCoordinatorSearch(onSelect) {
    return (
      <div>
        <div style={form.row}>
          <div style={form.labelWide}>Search Coordinator</div>
          <div style={form.searchWrap}>
            <input type="text" name="mobile_no" placeholder="Search for…" style={form.searchInput}
              value={this.state.mobile_no} onChange={(e) => { this.handleChangeForNew(e); }} />
            <button type="button" style={form.searchBtn} onClick={this.getSearchList}>🔍</button>
          </div>
        </div>

        {this.state.search && (
          <div style={{ marginBottom: 14 }}>
            {this.state.buddy_search_list.length ? (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {this.state.buddy_search_list.map(x => (
                  <button key={x.mobile_no + x.name} type="button"
                    style={{ ...btn.outline, fontSize: 12, padding: '6px 12px' }}
                    onClick={() => onSelect(x.name, x.id, x.mobile_no)}>
                    {x.name}: {x.mobile_no}
                  </button>
                ))}
              </div>
            ) : (
              <div style={searchStyles.notFound}>
                <span style={searchStyles.notFoundText}>Search customer not found</span>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  render() {
    console.log(this.state);
    console.log("in render");

    const prev = this.state.prev_competition_details;

    // Only block render with spinner in edit mode while fetching competition data.
    // In addnew mode is_loading stays false so the add form renders immediately.
    if (this.state.is_loading) {
      return (
        <div style={spinner.wrap}>
          <Spinner name="line-scale-pulse-out-rapid" color={spinner.color} />
        </div>
      );
    }

    return (
      <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif" }}>

        {this.state.showStructure &&
          <TournamentStructure id={this.state.tournament_id} initialView={this.state.showStructure} competitions_id={this.state.competitions_id} />
        }

        {/*{ this.state.ShowCompetition &&
          <div style={styles.button_view} className="col-md-12">
            <input className="button" type="button" value="Add Competition" onClick={() => {this.toAddCompetitionView()}} style={styles.input_button}/>
          </div>
        }
        { ! this.state.initialView && this.state.addNewCompetitionView &&
          <div style={styles.button_view} className="col-md-12">
            <input type="button" value="Show Competition" style={styles.input_button} onClick={()=>{this.toShowCompetitionView()}}/>
          </div>
        }*/}

        {/* ── Edit Competition ── */}
        {this.state.ShowCompetition && prev &&
          <div>
            <div style={{ padding: '20px 24px' }}>
                <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

                  <div style={form.row}>
                    <div style={form.labelWide}>Game</div>
                    <select name="game" style={form.select} value={this.state.value} onChange={(e) => { this.handleChange(e); }}>
                      {this.state.games.map((x, index) => (
                        <option selected={prev.game && prev.game[0] == x.pk && x} key={x.pk} value={x.pk}>{x.name}</option>
                      ))}
                    </select>
                  </div>

                  {(!prev.is_team_competition || (prev.game && prev.game[1] && prev.game[1] == "Badminton")) &&
                    <div style={form.row}>
                      <div style={form.labelWide}>Category</div>
                      <select name="category" style={form.select} value={this.state.value} onChange={(e) => { this.handleChange(e); }}>
                        {this.state.categories.map((category, index) => (
                          <option key={index} selected={prev.category && prev.category[0] == category[0] && category[0]} value={category[0]}>{category[1]}</option>
                        ))}
                      </select>
                    </div>
                  }

                  {!prev.is_team_competition &&
                    <div style={form.row}>
                      <div style={form.labelWide}>Gender</div>
                      <select name="gender" style={form.select} value={this.state.value} onChange={(e) => { this.handleChange(e); }}>
                        {this.state.genders.map((gender, index) => (
                          <option key={index} selected={prev.gender && prev.gender[0] == gender[0] && gender[0]} value={gender[0]}>{gender[1]}</option>
                        ))}
                      </select>
                    </div>
                  }

                  <div style={form.row}>
                    <div style={form.labelWide}>Age Group</div>
                    <select name="age_groups" id="age_groups" style={form.select} value={this.state.value} onChange={(e) => { this.handleChange(e); }}>
                      {this.state.age_groups.map((age_group, index) => (
                        <option key={index} selected={prev.age_groups && prev.age_groups[0] == age_group.id && age_group.id} value={age_group.id}>{age_group.name}</option>
                      ))}
                    </select>
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>Start Date</div>
                    <DatePicker dateFormat="DD/MM/YYYY" selected={moment(prev.start_date && prev.start_date[1])} onChange={this.handleStartDatePre} />
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>End Date</div>
                    <DatePicker dateFormat="DD/MM/YYYY" selected={moment(prev.end_date && prev.end_date[1])} onChange={this.handleEndDatePre} />
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>Registration End Date</div>
                    <input type="datetime-local" name="registration_closed" style={form.input}
                      onChange={(e) => this.handleRegDateTime(e)}
                      value={moment(prev.registration_closed && prev.registration_closed[1]).format('YYYY-MM-DDTHH:mm')} />
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>Venues</div>
                    <select name="venue" id="venue" style={form.select} value={this.state.value} multiple={true} onChange={(e) => { this.handleMultiselectPrev(e); }}>
                      {Object.keys(this.state.venues).map((key, index) => (
                        <option key={index} value={this.state.venues[key].id}>{this.state.venues[key].name}</option>
                      ))}
                    </select>
                  </div>
                  <div style={{ marginBottom: 14, paddingLeft: 212 }}>
                    <small style={{ color: colors.muted, fontSize: 11 }}>* use &lt;Ctrl&gt; for multiple selection</small>
                  </div>

                  {this.state.additional_fields.includes('cities') &&
                    <div style={form.row}>
                      <div style={form.labelWide}>City</div>
                      <select name="city" id="city" style={form.select} value={this.state.value} onChange={(e) => { this.handleChange(e); }}>
                        {this.state.city.map((city, index) => (
                          <option key={index} selected={prev.city && prev.city.id == city.id && city} value={city.id}>{city.name}</option>
                        ))}
                      </select>
                    </div>
                  }

                  {this.renderCoordinatorSearch((name, id, mobile) => this.setCordinater(name, id, mobile))}

                  {prev.coordinator &&
                    <div style={form.row}>
                      <div style={form.labelWide}>Selected Coordinators</div>
                      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
                        {prev.coordinator.map((coordinator, index) => (
                          <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span style={{ fontSize: 13, color: colors.text }}>{coordinator[1]}</span>
                            <button type="button" style={{ ...btn.dangerLt, padding: '3px 8px', fontSize: 11 }}
                              onClick={() => { this.removeCoordinater(coordinator[0], coordinator[1]); }}>✕</button>
                          </div>
                        ))}
                      </div>
                    </div>
                  }

                  {/*<div style={form.row}>
                    <div style={form.labelWide}>Prize and Perks</div>
                    <textarea rows="4" style={form.textarea} name="prize_and_perks" defaultValue={prev.prize_and_perks} onChange={(e) => { this.handleChange(e); }} />
                  </div>
                  <div style={form.row}>
                    <div style={form.labelWide}>Description</div>
                    <textarea rows="4" style={form.textarea} name="description" defaultValue={prev.description} onChange={(e) => { this.handleChange(e); }} />
                  </div>*/}

                  <div style={form.row}>
                    <div style={form.labelWide}>Registration Amount</div>
                    <input type="number" style={form.input} name="registration_amount" className="required"
                      defaultValue={prev.registration_amount} onChange={(e) => { this.handleChange(e); }} />
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: 16, borderTop: `1px solid ${colors.border}`, marginTop: 8 }}>
                    <button type="button" style={btn.primary} onClick={() => { this.postSaveCompetition(); }}>Save</button>
                    {/*
                    <button type="button" style={btn.danger} onClick={() => { this.toShowCompetitionView(); }}>Cancel</button>
                    */}
                  </div>

                </form>
            </div>
          </div>
        }

        {/* ── Add Competition ── */}
        {this.state.addNewCompetitionView &&
          <div style={{ padding: '24px' }}>
            <div style={{ ...card.wrap, maxWidth: 680 }}>
              <div style={card.header}>
                <h2 style={card.title}>Add Competition</h2>
              </div>
              <div style={{ padding: '20px 24px' }}>
                <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

                  <div style={form.row}>
                    <div style={form.labelWide}>Game</div>
                    <select name="game" style={form.select} value={this.state.value} onChange={(e) => { this.handleChangeForNew(e); }}>
                      {this.state.games.map((x, index) => (
                        <option key={x.pk} value={x.pk}>{x.name}</option>
                      ))}
                    </select>
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>Category</div>
                    <select name="category" style={form.select} value={this.state.value} onChange={(e) => { this.handleChangeForNew(e); }}>
                      {this.state.categories.map((format, index) => (
                        <option key={index} value={format[0]}>{format[1]}</option>
                      ))}
                    </select>
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>Gender</div>
                    <select name="gender" style={form.select} value={this.state.value} onChange={(e) => { this.handleChangeForNew(e); }}>
                      {this.state.genders.map((format, index) => (
                        <option key={index} value={format[0]}>{format[1]}</option>
                      ))}
                    </select>
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>Age Group</div>
                    <select name="age_group" id="age_group" style={form.select} value={this.state.value} onChange={(e) => { this.handleChangeForNew(e); }}>
                      {this.state.age_groups.map((age_group, index) => (
                        <option key={index} value={age_group.id}>{age_group.name}</option>
                      ))}
                    </select>
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>Start Date</div>
                    <DatePicker selected={this.state.competition_details.start_date} onChange={this.handleStartDate} />
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>End Date</div>
                    <DatePicker selected={this.state.competition_details.end_date} onChange={this.handleEndDate} />
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>Registration End Date</div>
                    <DatePicker selected={this.state.competition_details.registration_closed && this.state.competition_details.registration_closed} onChange={this.handleRegDate} />
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>Venues</div>
                    <select name="venue" id="venue" style={form.select} value={this.state.value} multiple={true} onChange={(e) => { this.handleMultiselect(e); }}>
                      {Object.keys(this.state.venues).map((key, index) => (
                        <option key={index} value={this.state.venues[key].id}>{this.state.venues[key].name}</option>
                      ))}
                    </select>
                  </div>
                  <div style={{ marginBottom: 14, paddingLeft: 212 }}>
                    <small style={{ color: colors.muted, fontSize: 11 }}>* use &lt;Ctrl&gt; for multiple selection</small>
                  </div>

                  {this.state.coordinaters.length > 0 &&
                    <div style={form.row}>
                      <div style={form.labelWide}>Selected Coordinators</div>
                      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
                        {this.state.coordinaters.map((coordinator, index) => (
                          <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span style={{ fontSize: 13, color: colors.text }}>{coordinator[1]}</span>
                            <button type="button" style={{ ...btn.dangerLt, padding: '3px 8px', fontSize: 11 }}
                              onClick={() => { this.removeCoordinater(coordinator[0], coordinator[1]); }}>✕</button>
                          </div>
                        ))}
                      </div>
                    </div>
                  }

                  {this.renderCoordinatorSearch((name, id, mobile) => this.setSearch(name, id, mobile))}

                  <div style={form.row}>
                    <div style={form.labelWide}>Prize and Perks</div>
                    <textarea rows="4" style={form.textarea} name="prize_and_perks" placeholder="Enter Prize and Perks"
                      onChange={(e) => { this.handleChangeForNew(e); }} />
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>Description</div>
                    <textarea rows="4" style={form.textarea} name="description" placeholder="Enter Competition Description"
                      onChange={(e) => { this.handleChangeForNew(e); }} />
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>Registration Amount</div>
                    <input type="number" style={form.input} name="registration_amount" className="required"
                      value={this.state.value} onChange={(e) => { this.handleChangeForNew(e); }} />
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: 16, borderTop: `1px solid ${colors.border}`, marginTop: 8 }}>
                    <button type="button" style={btn.primary} onClick={() => { this.postCreateCompetition(); }}>Create</button>
                  </div>

                </form>
              </div>
            </div>
          </div>
        }

      </div>
    );
  }
}

export default TournamentCompetition;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/tournamentCompetition/index.js